// extracted by mini-css-extract-plugin
export default {"text-area":"CaptionEditModal--text-area--gXn73","textArea":"CaptionEditModal--text-area--gXn73"};